var screenSm = 576,
    screenMd = 768,
    screenLg = 992,

    heroBgLoaded = false,
    heroImgLoaded = false;

function varResizer(){
	wh = $(window).height();
	ww = $(window).width();
	wtop = $(window).scrollTop();
	wbottom = wtop + wh;
};

function varScroller(){
	wtop = $(window).scrollTop();
	wbottom = wtop + wh;
}

$(function(){
	varResizer();

	$(window).on('scroll', function(e){
		e.preventDefault();
		varScroller();
	});

	$(window).resize(function(){
		varResizer();
	});
});

function checkWindowWidth(fc1, fc2, fc3) {
    fc1 = fc1 || (function(){});
    fc2 = fc2 || (function(){});
    fc3 = fc3 || (function(){});

    if (ww <= screenSm) {
        fc1();
    } else if ((ww <= screenMd)) {
        fc2();
    } else {
        fc3();
    }
}